<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>TRADERS</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right">                       
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                            <i @click="searchTrader()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                            <input v-on:keyup.enter="searchTrader" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
                            <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form> 
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >TRADER</th>
                                    
                                    <th 
                                    scope="col" 
                                    class="text-left">Max Concurrent Bidwanteds</th>
                                    <th scope="col" class="text-center">ACTION</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="trader in traders" :key="trader.id">
                                <td class="text-center">{{trader.firstName }} {{trader.lastName}}</td>
                                <td class="text-center">
                                   <input v-model="trader.bidWantedMaxCount" type="number" class="form-control form-control-sm" />
                                </td>
                                <td class="text-center">
                                    <button @click="saveTrader(trader)" class="btn btn-primary btn-sm"><i class="fas fa-save"></i> Save</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getTraderList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
       
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
  name: "imstradersComponent",
  components : {
      
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "firstName",
        sortOrder: "ASC",
        traderData : null,
        traderEditModalOpen : false,
        traders : [],
        accountList : [],
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        
     
    };
  },
  methods: {
    searchTrader(){
        this.getTraderList();
    },
    clearSearch(){
        this.searchValue = "";
        this.getTraderList();
    },
    getTraderList(){
        this.loading = true;
        
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=ACTIVE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&group=Drl-Trader",
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.traders = result.data.content;
          this.loading = false;
        })
    },
    saveTrader(trader) {
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .put(
            config.baseUrlBidSide + "/user",
            trader,
            auth
        )
        .then(() => {
            this.loading = false;
            this.$alert("Trader setting updated successfully.","","success");
            this.getTraderList();
        })
        .catch(() => {
            this.loading = false;
        });
    },
  },
  mounted() {
    this.getTraderList();
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
    });
  }
};
</script>